import { render, staticRenderFns } from "./Uploadvideo.vue?vue&type=template&id=15792142&"
import script from "./Uploadvideo.vue?vue&type=script&lang=js&"
export * from "./Uploadvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports